import styled from "styled-components";

export const Wrapper = styled.div`
    flex-direction: column;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
`;

export const TextWrapper = styled.div`
    width: 400px;
`;

export const KeyboardWrapper = styled.div`
    width: 100%;
    padding: 1rem;
    box-sizing: border-box;
`